
    var riot = require('riot')
    riot.tag2('gb-sayt-search-terms', '<gb-list items="{$sayt.queries}"> <gb-sayt-link send="{$sayt.search}" data-value="{$item.value}"> <yield> <gb-raw content="{$sayt.highlightCurrentQuery($item.value, \'<b>$&</b>\')}"></gb-raw> </yield> </gb-sayt-link> </gb-list>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-search-terms.tag.html